// Upsell card.
//
// The tick does not post and it does not touch the product form. It says what
// it would add and nextdev-product-form.js does the rest: one listener on the
// form, one request for every extra line, one group tying them to the bed, so
// the drawer draws the add on under it and takes it out with it. The form
// itself stays one line, so nextdev-product-form.js does what it always does:
// posts the bed, shows its own error, opens its own cart.
//
// Catching the submit here instead was what this did first, and it cannot be
// done by two snippets at once: see the note at the top of
// nextdev-product-form.js.
//
// Writing "items[n][id]" into the product form would send no extra request at
// all, but it changes the shape of what the cart answers with, and a theme that
// reads that answer for the line it just added has nothing to read.

(function () {
  'use strict';

  function start(card) {
    if (card.dataset.nextdevUpsellInit) return;
    card.dataset.nextdevUpsellInit = '1';

    var input = card.querySelector('[data-nextdev-upsell-input]');
    var option = card.querySelector('[data-nextdev-upsell-option]');
    if (!input || !option) return;

    // ---- the tick reads as a choice ----

    function markChosen() {
      option.classList.toggle('nextdev--pdp__upsell-card-option--selected', input.checked);
    }

    input.addEventListener('change', markChosen);
    markChosen();

    // ---- the form the add on goes into ----

    // Named, or the product form the page already has.
    function findForm() {
      var named = card.getAttribute('data-form');
      if (named) {
        var byId = document.getElementById(named);
        if (byId) return byId.tagName === 'FORM' ? byId : byId.querySelector('form');
      }
      return document.querySelector('form.nextdev--pdp__form')
        || document.querySelector('nextdev-product-form form')
        || null;
    }

    var form = findForm();
    if (!form) return;

    // ---- what this would add ----

    if (window.nextdevCartCombine) {
      window.nextdevCartCombine.register(form, function () {
        // nothing goes in while the tick is off
        if (!input.checked) return null;
        return { id: input.value, quantity: 1 };
      });
    }

    // ---- the window behind the link ----

    var modal = document.querySelector('[data-nextdev-upsell-fit-modal]');
    if (!modal) return;

    function openFit() {
      modal.classList.remove('nextdev--pdp__upsell-card-modal--hidden');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
    }

    function closeFit() {
      modal.classList.add('nextdev--pdp__upsell-card-modal--hidden');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
    }

    card.querySelectorAll('[data-nextdev-upsell-fit]').forEach(function (trigger) {
      trigger.addEventListener('click', openFit);
    });
    modal.querySelectorAll('[data-nextdev-upsell-fit-close]').forEach(function (button) {
      button.addEventListener('click', closeFit);
    });
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeFit();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.classList.contains('nextdev--pdp__upsell-card-modal--hidden')) {
        closeFit();
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-nextdev-upsell]').forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // the theme editor draws a section again after a change
  document.addEventListener('shopify:section:load', boot);
})();